"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const MainSetupReact_1 = __importDefault(require("../MainSetupReact"));
class ToolsFetch {
    static getClientErrorSecret() {
        const runtimeSecret = window.__BUG_CLIENT_ERROR_SECRET__;
        if (typeof runtimeSecret === "string" && runtimeSecret.trim().length > 0) {
            return runtimeSecret.trim();
        }
        const storageSecret = window.localStorage.getItem("BUG_CLIENT_ERROR_SECRET");
        if (typeof storageSecret === "string" && storageSecret.trim().length > 0) {
            return storageSecret.trim();
        }
        return null;
    }
    /** Dla ścieżek omijających fetchJsonWithSafeError (własna obsługa błędów). */
    static notifySessionExpired() {
        this.handleSessionExpired();
    }
    static handleSessionExpired() {
        // Ekran logowania sam odpytuje /session i dostaje 401 - to normalny stan startowy,
        // nie wygaśnięcie. Reagujemy tylko, gdy klient miał zapamiętanego użytkownika.
        if (!MainSetupReact_1.default.currentUserOrNull)
            return;
        // Jedno przeładowanie na sesję - równoległe żądania nie mogą zapętlić strony.
        if (this.sessionExpiredHandled)
            return;
        this.sessionExpiredHandled = true;
        console.warn("Sesja wygasła lub została unieważniona - przechodzę do ekranu logowania.");
        window.sessionStorage.clear();
        window.location.reload();
    }
    static async fetchJsonWithSafeError(url, options = {}, customErrorMsg) {
        let httpStatus;
        try {
            const response = await fetch(url, options);
            if (!response.ok) {
                httpStatus = response.status;
                if (httpStatus === 401)
                    this.handleSessionExpired();
                const errorDetails = await response.json();
                throw new Error(errorDetails.errorMessage);
            }
            return await response.json();
        }
        catch (error) {
            let wrapped;
            if (error instanceof TypeError && httpStatus === undefined) {
                wrapped = new Error(customErrorMsg || `Brak połączenia z serwerem, sprawdź połączenie internetowe`);
            }
            else if (error instanceof Error) {
                wrapped = new Error(customErrorMsg || error.message);
            }
            else {
                wrapped = new Error(customErrorMsg || `Nieznany błąd klienta`);
            }
            // Status HTTP jest potrzebny wywołującemu, by odróżnić błąd deterministyczny
            // (4xx — powtórka nic nie da) od chwilowego (5xx / brak sieci).
            if (httpStatus !== undefined)
                wrapped.status = httpStatus;
            throw wrapped;
        }
    }
    /** Funkcja pomocnicza do ponawiania żądań */
    static async fetchWithRetry(url, options, retries = 3, delay = 1000, customErrorMsg) {
        const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
        for (let i = 0; i < retries; i++) {
            try {
                return await this.fetchJsonWithSafeError(url, options, customErrorMsg);
            }
            catch (error) {
                if (this.isNonRetryable(error) || i === retries - 1)
                    throw error;
                await sleep(delay);
            }
        }
    }
    static isNonRetryable(error) {
        const status = error?.status;
        return typeof status === "number" && this.NON_RETRYABLE_STATUSES.includes(status);
    }
    /**
     * Wysyła raport błędu klienta na serwer
     * @param error - błąd do zgłoszenia
     * @param additionalData - dodatkowe dane kontekstowe
     */
    static async sendClientErrorReport(error, additionalData) {
        try {
            const secret = this.getClientErrorSecret();
            const message = error instanceof Error ? error.message : String(error || "Unknown client error");
            const stack = error instanceof Error ? error.stack : undefined;
            const errorData = {
                message,
                stack,
                path: window.location.pathname,
                route: window.location.hash || window.location.pathname,
                userAgent: navigator.userAgent,
                tags: ["frontend", "repository"],
                statusCode: 500,
                context: {
                    repositoryName: additionalData?.repositoryName,
                    action: additionalData?.action,
                    details: additionalData,
                },
            };
            const headers = {
                "Content-Type": "application/json",
            };
            if (secret) {
                headers["x-client-error-secret"] = secret;
            }
            await fetch(MainSetupReact_1.default.serverUrl + "client-error", {
                method: "POST",
                headers,
                credentials: "include",
                body: JSON.stringify(errorData),
            });
            console.log("Raport błędu klienta został wysłany na serwer");
        }
        catch (reportError) {
            console.error("Nie udało się wysłać raportu błędu klienta:", reportError);
        }
    }
}
/**
 * Sesja padła po stronie serwera, mimo że klient uważał się za zalogowanego.
 * Dzieje się tak, gdy komuś zmieniono rolę systemową (backend kasuje wtedy jego sesje,
 * żeby nowe uprawnienia obowiązywały od razu) albo gdy sesja wygasła.
 *
 * Bez tego użytkownik dostawałby serię komunikatów o błędach i dopiero po ręcznym
 * odświeżeniu strony zobaczyłby ekran logowania.
 *
 * Czyścimy CAŁY sessionStorage, nie tylko dane użytkownika: leżą tam też podręczne kopie
 * repozytoriów i wyników tabel, a po zmianie roli są to dane, których zalogowany
 * ponownie może już nie mieć prawa oglądać.
 */
ToolsFetch.sessionExpiredHandled = false;
/**
 * Statusy deterministyczne: powtórka da dokładnie ten sam błąd, a niepotrzebnie
 * powtórzy ciężkie operacje serwera (transakcja + Google Drive) — tak powstawały
 * trzy identyczne 409 z jednego kliknięcia "Zatwierdź".
 * Celowo BEZ 404 (wyścig przy odpytywaniu /sessionTaskStatus) i BEZ 429 (rate limiter
 * jest oknem czasowym) — tam ponowienie ma sens.
 */
ToolsFetch.NON_RETRYABLE_STATUSES = [400, 401, 403, 409, 422, 428];
exports.default = ToolsFetch;
